import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const rows = [
  ['Fecha', c => c.fecha_caso],
  ['Provincia', c => c.provincia],
  ['Localidad', c => c.localidad],
  ['Especies', c => c.comparacion?.especies],
  ['Edades registradas', c => c.comparacion?.edades],
  ['Antecedentes y signos descritos', c => c.comparacion?.antecedentes],
  ['Observaciones', c => c.comparacion?.observaciones],
  ['Diagnóstico primario', c => c.diagnostico_primario],
  ['Diagnóstico secundario', c => c.diagnostico_secundario],
  ['Muestras', c => c.comparacion?.muestras],
  ['Pruebas y resultados', c => c.comparacion?.resultados],
];
const display = value => (Array.isArray(value) ? value.join('\n') : value) || 'Sin dato registrado';

export default function CaseComparison({ cases, referenceId }) {
  const [differencesOnly, setDifferencesOnly] = useState(false);
  if (cases.length < 2) return null;
  return <section className="research-panel" aria-label="Comparador de casos">
    <h2>Comparar {cases.length} casos</h2>
    <p>Las diferencias resaltadas corresponden al texto registrado. Un dato faltante no indica ausencia del signo o de la enfermedad.</p>
    <label><input type="checkbox" checked={differencesOnly} onChange={e => setDifferencesOnly(e.target.checked)} /> Mostrar solo diferencias</label>
    <div className="research-comparison-scroll" tabIndex={0} role="region" aria-label="Tabla comparativa desplazable">
      <table className="research-comparison"><thead><tr><th scope="col">Característica</th>{cases.map(c => <th key={c.protocolo_general} scope="col"><Link to={`/ver-caso/${encodeURIComponent(c.protocolo_general)}`}>Caso {c.protocolo_general}</Link>{referenceId === c.protocolo_general && <small>Referencia</small>}</th>)}</tr></thead>
        <tbody>{rows.map(([label, get]) => {
          const values = cases.map(c => display(get(c)));
          const different = new Set(values).size > 1;
          if (differencesOnly && !different) return null;
          return <tr key={label} className={different ? 'research-comparison-different' : ''}><th scope="row">{label}</th>{values.map((value, index) => <td key={cases[index].protocolo_general}>{value}</td>)}</tr>;
        })}</tbody>
      </table>
    </div>
  </section>;
}
